import { render } from "./ProductAddBasic.vue?vue&type=template&id=761908f4&scoped=true"
import script from "./ProductAddBasic.vue?vue&type=script&lang=js"
export * from "./ProductAddBasic.vue?vue&type=script&lang=js"

import "./ProductAddBasic.vue?vue&type=style&index=0&id=761908f4&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761908f4"]])

export default __exports__